import { Schema } from "effect";

export const MessageSmsService = Schema.Literal(
  "SMS",
  "MMS",
  "RCS",
  "iMessage",
  "APPLE_MESSAGES",
);
export type MessageSmsService = typeof MessageSmsService.Type;
